import { render, staticRenderFns } from "./shiftManagement.vue?vue&type=template&id=0b34815c&scoped=true"
import script from "./shiftManagement.vue?vue&type=script&lang=js"
export * from "./shiftManagement.vue?vue&type=script&lang=js"
import style0 from "./shiftManagement.vue?vue&type=style&index=0&id=0b34815c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b34815c",
  null
  
)

export default component.exports